<template>
	<section class="coopmain">
		<!-- <feedback /> -->

		<!-- banner -->
		<div class="banner-box">
			<swiper :options="swiperOption" ref="mySwiper" v-if="bannerList.length > 0">
				<swiper-slide v-for="(item, index) in bannerList" :key="index">
					<a :href="item.tb_url" target="_blank">
						<img :src="item.tb_image_url" class="banner-img cup" alt="">
					</a>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>

		<div class="cooperation-box pl pr" ref="cooperationbox">

			<!-- <div class="cooperation-tab df aic jcsb">
				<div class="left">
					<span :class="{ 'active': cooperateType == 1 }" @click="cooperateType = 1">{{ $t("企业会员") }}</span>
					<span :class="{ 'active': cooperateType == 2 }" @click="cooperateType = 2">{{ $t("KOL会员") }}</span>
				</div>
			</div> -->

			<div class="cooperation-card df" :class="{'show':coopShowAll}">
				<div class="innerbox df fww">
					<a href="javascript:;" v-for="(item, index) in cooperatelist" :key="index"
						@click="tabsHandle(item.tcb_id)" :class="{ 'active': cooperate_id == item.tcb_id }" class="list df aic">
						<img :src="item.tcb_thumb" class="logo">
						<div class="text-box">
							<div class="t1 one-text">{{ item.tcb_title }}</div>
							<div class="desc tow-text fww">{{ item.tct_keywords.join(",") }}</div>
						</div>
					</a>
				</div>
				<div class="more" v-if="cooperatelist.length>5" @click="coopShowAll=!coopShowAll">{{$t('更多')}} <span class="iconfont">&#xe7e2;</span></div>
			</div>

			<div class="cooperation-type df fww aic jcsb">
				<div class="cooperation-tabs df fn">
					<a href="javascript:;" v-for="(item, index) in columnlist" :key="index"
						@click="tabsHandle2(item.tcbc_id, item.tcbc_temp_type)"
						:class="{ 'active': column_id == item.tcbc_id }"
						class="one-text filter-btn reset-page column-filter-btn">
						{{ item.tcbc_title }}({{ item.count }})
					</a>
				</div>
				<form class="f1 df jcfe aic search-key-form-form">
					<div class="ipt df aic" :class="{'hide':iptHide}">
						<input type="text" class="f1 filter-search" :placeholder="$t('请输入关键字')" v-model="keyword">
						<span class="iconfont search-cancel inside-search-clear"
							@click="keyword = '';handleSearch()">&#xe63f;</span>
						<button type="button" class="filter-btn filter-search-btn reset-page"
							@click="handleSearch()">
							<span class="iconfont">&#xe8b9;</span>
						</button>
					</div>
					<template v-if="admin_data">
						<button @click="showDialog" class="b2 open_issue" type="button"><span
								class="iconfont">&#xe623;</span>{{ $t("发布") }}</button>
						<button @click="showCooperateAskDialog" class="b1 open_issue" type="button"><span
								class="iconfont">&#xe623;</span>{{ $t("提问") }}</button>
					</template>
					<button v-else @click="showCooperateAskDialog" class="b2 open_issue" type="button"><span
							class="iconfont">&#xe623;</span>{{ $t("提问") }}</button>
				</form>
			</div>

			<!-- 内容部分 -->
			<!-- 方案 -->
			<div class="cooperation-substance df jcsb">
				<div class="left-box">
					<!-- 目录 -->
					<div class="catalogue">
						<div class="main-title df aic">{{ $t("目录") }}</div>

						<div class="demo-tree">
							<el-tree ref="treeRef" :data="directorylist" node-key="tcbcd_id"
								:current-node-key="directory_id" :highlight-current="true" :default-expand-all="true"
								:expand-on-click-node="false" icon-class="el-icon-arrow-right"
								@current-change="tabsHandle32" :props="defaultProps">
							</el-tree>
						</div>

					</div>
					<!-- 快速;链接 -->
					<div class="cooperation-link" v-show="columnLinkList.length > 0">
						<div class="main-title df aic">{{ $t("快速链接") }}</div>
						<div class="link-box">
							<a v-for="item in columnLinkList" :key="item.tcbcl_id" :href="item.tcbcl_url"
								target="_blank" class="list2 df aic">
								<div class="name f1 tow-text" :title="item.tcbcl_title">{{ item.tcbcl_title }}</div>
							</a>
							<!-- <a v-for="item in columnLinkList" :key="item.tcbcl_id" :href="item.tcbcl_url"
								target="_blank" class="list df aic">
								<div class="logo"> 
									<img :src="item.tcbcl_thumb_arr" class="logo" alt="">
								</div>
								<div class="name f1 tow-text" :title="item.tcbcl_title">{{ item.tcbcl_title }}</div>
								<span class="iconfont">&#xe79a;</span>
							</a> -->
						</div>
					</div>
				</div>
				<div class="right-box">

					<div class="right-contentbox">
						<div class="community-center">
							<h3>{{ dirtitle }}</h3>
							<div class="option-box">
								<el-radio-group @change="getArticleList" v-model="sort_method">
									<el-radio label="">{{ $t("全部") }}</el-radio>
									<el-radio label="10">{{ $t("最新") }}</el-radio>
									<el-radio label="20">{{ $t("最热") }}</el-radio>
									<el-radio label="30">{{ $t("精华") }}</el-radio>
									<el-radio label="40">{{ $t("我发布") }}</el-radio>
								</el-radio-group>
								<el-button v-if="admin_data" type="primary" round size="mini" 
									@click="adminEdit = !adminEdit">{{ adminEdit ? $t("完成") : $t("编辑") }}</el-button>
							</div>
						</div>

						<div class="cooperation-list" v-if="tcbc_temp_type != 30 && tcbc_temp_type != 40">
							<a v-for="(item, index) in articlelist" :key="index" class="list" :class="{'red':item.tcba_rec == 1000}">
								<div class="topbox" :class="{'en':Language=='en'}">
									<div class="topleft">
										<div class="essence-box red" v-if="item.tcba_rec == 900">{{$t('精2')}}</div>
										<div class="essence-box" v-if="item.tcba_rec == 1000">{{$t('顶')}}</div>
										<img v-if="item.tcba_link_type == 20 && item.tcba_temp_type == 20"
											:src="getDoc(item.tcba_annex_arr[0].att_title)" class="logo" alt=""
											data-bd-imgshare-binded="1">
										<div class="titles one-text"
											@click="handleLink(item.tcba_id, item.tcba_link, item.tcba_link_type,item)">
											{{ item.tcba_title }}
										</div>
									</div>
									<div class="edit-btn f1 jcfe df" v-if="admin_data && adminEdit">
										<el-button size="mini" type="text" v-throttle="2000"
											@click.stop="handleTopUp(item)" v-if="item.tcba_rec != 900">
											{{ item.tcba_rec == 1000 ? $t("取消置顶") : $t("置顶") }}
										</el-button>
										<el-button size="mini" type="text" v-throttle="2000"
											@click.stop="handlesSetEssence(item)" v-if="item.tcba_rec != 1000">
											{{ item.tcba_rec == 900 ? $t("取消置精华") : $t("置精华") }}
										</el-button>
										<el-button size="mini" type="text" v-throttle="2000"
											@click.stop="handleDelAdmin(item)">{{ $t("删除") }}</el-button>
										<el-button size="mini" type="text" v-throttle="2000"
											@click.stop="handleEdit(item)">{{ $t("编辑") }}</el-button>
									</div>
								</div>
								<div class="data-btn df fww">
									<div class="date-box fn">
										<span>{{ item.update_time }}</span>
										<span v-if="item.tcba_link_type == 20 && item.tcba_temp_type == 20">
											{{ item.tcba_annex_arr[0].att_size }}MB
										</span>
									</div>
									<div class="dow-btn df aic fn">
										<div class="download-a" v-if="item.tcba_link_type == 20 && item.tcba_temp_type==20" v-throttle="2000"
											@click.stop="downloadFile(item, index)">
											<span class="iconfont">&#xe621;</span>
											<span class="number">{{$t('下载')}}({{ item.tcba_annex_arr[0].download_times }})</span>
										</div>
										
										<el-tooltip placement="top" effect="light" v-if="item.tcba_link_type == 10">
											<div class="hits" slot="content">
												{{$t("仅华为伙伴可下载")}}
											</div>
											<div class="download-a disabled">
												<span class="iconfont">&#xe621;</span>
												<span class="number">{{$t('下载')}}</span>
											</div>
										</el-tooltip>

										<div class="hits" v-if="item.tcba_link_type == 10">
											<span class="iconfont">&#xe611;</span>
											<span class="number">{{$t('浏览')}}({{ item.tcba_hits }})</span>
										</div>
										<div class="bdsharebuttonbox shares-box share-box" v-if="item.tcba_link_type == 20"
										 @mouseover="showShareMenu(item)"
										 @click="handleShare(item, index)"
										 v-throttle="1000">
											<a href="javaScript:void(0);" class="bds_more hezuohare" :data-cmd="Language == 'zh' ? 'more' : ''">
												<span class="iconfont">&#xe620;</span> <span
													id="share-count-294">{{$t('分享')}}({{ item.tcba_share }})</span>
											</a>
											<!-- 英文版分享 -->
											<div class="sharewx-link" style="position: absolute;" v-if="Language != 'zh'">
												<div class="bdsharebuttonbox df fdc">
													<a href="#" class="bds_weixin" data-cmd="weixin" title="WeChat">WeChat</a>
													<a href="#" class="bds_linkedin" data-cmd="linkedin" title="linkedin">LinkedIn</a>
												</div>
											</div>
										</div>
										<div class="cooperate-collection-btn" v-if="item.tcba_temp_type==20" :class="{ 'sel': item.have_collection }"
											@click.stop="handleLike(item, index)">
											<span class="iconfont" v-if="item.have_collection">&#xe616;</span>
											<span class="iconfont" v-else>&#xe65e;</span>
											{{ $t("收藏") }}
										</div>
									</div>
								</div>
							</a>
						</div>
						<!-- 问答列表 -->
						<div class="cooperation-answer" v-if="tcbc_temp_type == 40">
							<a v-for="(item, index) in articlelist" :key="index"
								@click="handleLink(item.tcba_id, item.tcba_link, item.tcba_link_type,item)" class="df list">
								<div class="text-box">
									<div class="topbox">
										<div class="topleft">
											<div class="t1 tow-text">
												{{ item.tcba_title }} 
											</div> 
											<div class="rightbtn">
												<el-tag size="mini" type="warning" v-if="item.tcba_is_typical == 10">
													{{ $t("典型疑问")}}
												</el-tag>
												<el-tag size="mini" type="success" v-if="item.tcba_is_solve == 10">
													{{ $t("已解决")}}
												</el-tag>
											</div>
										</div>
										<div class="edit-btn df">
											<el-button size="mini" type="text"
												v-if="!admin_data && item.user_id == userinfo.user_id" v-throttle="2000"
												@click.stop="handleDel(item)">{{ $t("删除") }}</el-button>
											<template v-if="admin_data && adminEdit">
												<el-button size="mini" type="text" v-throttle="2000"
													@click.stop="handleDelAdmin(item)">{{ $t("删除") }}</el-button>
												<el-button size="mini" type="text" v-throttle="2000"
													@click.stop="handleSetTypical(item)" v-if="item.tcba_rec != 1000">
													{{ item.tcba_is_typical == 10 ? $t("取消典型疑问") : $t("典型疑问") }}
												</el-button>
											</template> 
											<el-button size="mini" type="text" v-throttle="2000"
												v-if="item.tcba_is_solve == 20 && (item.user_id == userinfo.user_id || (admin_data && adminEdit))"
												@click.stop="handleSolved(item)">{{
													$t("已解决") }}</el-button>
										</div>
									</div>
									<div class="bottom">
										<div class="titles" @click.stop="handleUserinfo(item.user_id)" v-throttle="1000">
											<el-avatar :size="30"
												:src="item.user_avatar_att_url || require('@/assets/images/avatar.png')"
												@error="$erroravatarHandler">
											</el-avatar>
											<p class="one-text">{{ item.user_nick_name }}</p>
										</div>
										<div class="dates df fww aic">
											<p><span class="iconfont">&#xe611;</span> {{ item.tcba_hits }}</p>
											<p><span class="iconfont">&#xe61b;</span> {{ item.tcba_likes }}</p>
											<p><span class="iconfont">&#xe63e;</span> {{ item.reply_count }}</p>
											<span>{{ item.update_time }}</span>
										</div>
									</div>
								</div>
							</a>
						</div>
						<!-- 视频列表 -->
						<div class="cooperation-video df fww" v-if="tcbc_temp_type == 30">
							<a @click="handleLink(item.tcba_id, item.tcba_link, item.tcba_link_type,item)" class="list"
								v-for="(item, index) in articlelist" :key="index">
								<div class="poster-box">
									<video ref="videoPlayer" @loadeddata="setCover(index)">
										<source :src="item.first_video_url" type="video/mp4">
									</video>
									<!-- <img src="video.png" class="video-icon" alt=""> -->
									<div class="video-number df">
										<span class="iconfont">&#xe62d; {{ item.tcba_hits }}{{ $t('次') }}</span>
										<span class="iconfont">&#xe63e; {{ item.reply_count }}</span>
										<!-- <span class="dates f1 df jcfe">00:20</span>-->
									</div>
								</div>
								<div class="t1 one-text">
									<div class="essence-box red" v-if="item.tcba_rec == 900">{{$t('精2')}}</div>
									<div class="essence-box" v-if="item.tcba_rec == 1000">{{$t('顶')}}</div>
									{{ item.tcba_title }}
								</div>
								<div class="date one-text">{{ item.update_time }}</div> 
								<div class="btns df fww" v-if="admin_data && adminEdit">
									<el-button size="mini" type="text" v-throttle="2000"
										@click.stop="handleTopUp(item)" v-if="item.tcba_rec != 900">
										{{ item.tcba_rec == 1000 ? $t("取消置顶") : $t("置顶") }}
									</el-button>
									<el-button size="mini" type="text" v-throttle="2000"
										@click.stop="handlesSetEssence(item)" v-if="item.tcba_rec != 1000">
										{{ item.tcba_rec == 900 ? $t("取消置精华") : $t("置精华") }}
									</el-button>
									<el-button size="mini" type="text" v-throttle="2000"
										@click.stop="handleDelAdmin(item)">{{ $t("删除")
										}}</el-button>
									<el-button size="mini" type="text" v-throttle="2000"
										@click.stop="handleEdit(item)">{{ $t("编辑")
										}}</el-button>
								</div>
							</a>
						</div>

						<div class="empty-box" v-if="articlelist.length == 0">
							<img :src="require('@assets/images/empty_data.png')" alt="" data-bd-imgshare-binded="1">
							<p class="text">{{ $t('暂无数据') }}</p>
						</div>


            <div class="pageing-box df aic jcc">
              <el-button type="text" class="add-btn" @click="handleCurrent(1)">{{
                  $t("回首页")
                }}</el-button>
              <el-pagination :current-page="pagination.page" :page-size="pagination.pageSize"
                             :total="pagination.total" layout="total,prev, pager, next, slot, sizes"
                             @current-change="handleCurrent" @size-change="handlePageSize">
                <span class="jump-text">{{ $t("跳转") }}</span>
                <el-input-number :controls="false" v-model="pagination.page" :min="1"
                                 :max="pagination.allPage" size="small" @change="handleCurrent(pagination.page)"
                                 class="jump-ipt" />
              </el-pagination>
              <el-button type="text" class="add-btn ml-11" @click="handleCurrent(pagination.allPage)">{{
                  $t("去尾页")
                }}</el-button>
            </div>


          </div>

				</div>
			</div>

		</div>

		<!-- 发帖子 -->
		<cooperateModel ref="cooperateDialog" :title="fbType == 40 ? $t('提问') : ''"
			:data_list="fbType == 40 ? directoryData : directorylist" :formData="formData"
			@post-submitted="handleSubmitted" />
		<!-- 置顶 -->
		<topup-model ref="topupDialog" :title="$t('置顶')" :id="top_id" @poster-submitted="topupSubmitted"
			:topLoading="topLoading"></topup-model>
		<!-- 个人信息 -->
		<avatarTop ref="avatarDialog" :publisherFollowLoading="publisherFollowLoading"
			@post-submitted="handlePostSubmitted" :id="user_id" />
	</section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
  cooperateList, columnList, directoryList,
  columnLinkList, articleList, topUp, setEssence,
  add, adminDel, del, editGet, edit, solved, setTypical, articleCollection, sharePoints, addExternalLinkHits
} from "@api/cooperate";
import { getBanner,setuserfollowAdd,getMyInfo } from "@api/home";
import cooperateModel from "@/components/cooperateModel.vue";
import topupModel from "@/components/topupModel.vue";
export default {
	name: "cooperate",
	components: {
		Swiper,
		SwiperSlide,
		cooperateModel,
		topupModel,
	},
	data() {
		return {
			formData: {},
			userinfo: {},
			fbType: 0,
			user_id: '',
			publisherFollowLoading: false,
			Language: localStorage.getItem('currentLanguage'),
			topLoading: false,
			publisherFollowLoading: false,
			user_id: "",
			top_id: 0,
			bannerList: [{
				tb_image_url: "https://www1.oceanclub.org.cn/storage/upload/img/20241101/1c5d8202411011406213437.png"
			}],
			coopShowAll: false,
			cooperateType: 1,
			cooperate_id: 0,
			admin_data: null,
			adminEdit: false,
			column_id: 1,
			tcbc_temp_type: "",
			directory_id: 1,
			dirtitle: "",
			cooperatelist: [],
			columnlist: [],
			directorylist: [],
			directoryData: [],
			defaultProps: {
				children: 'children',
				label: 'title'
			},
			columnLinkList: [],
			swiperOption: {
				// loop: true,
				// autoplay: {
				// 		delay: 6000, // 每6秒切换
				// 		disableOnInteraction: false, // 用户操作后是否禁用自动播放
				// },
				// 显示分页
				pagination: {
					el: ".swiper-pagination",
					clickable: true, //允许分页点击跳转
				},
			},
			sort_method: "",
			iptHide: true,
			keyword: "",
			articlelist: [],
			// 分页数据
			pagination: {
				page: 1,
				total: 0,
				pageSize: 10,
				allPage: 0,
			},

			jumpIndex: 1,
			data_list: {},
			vurl: "",
			download_able: true,
			shareItem: {},

			route_query: {},
		}
	},
	created() {
		this.route_query = {
			...this.$route.query
		}
		this.cooperate_id = this.route_query.cooperate_id || 0;
		this.column_id = this.route_query.column_id || 1;
		this.directory_id = this.route_query.directory_id || 1;
		this.dirtitle = this.route_query.dirtitle || "";

	},
	computed: {

		
		getCoopId() {
			return this.$route.query.cooperate_id; // 获取路由参数
		},
	},
	mounted() {
		this.getCoopId && (this.cooperate_id = parseInt(this.getCoopId));
		window.addEventListener('load', () => {
			// 页面完全加载完成后,滚动到内容区域
			const box = this.$refs.cooperationbox
			let posi = box.getBoundingClientRect().top+window.scrollY-60
			window.scrollTo({
				top: posi,
				behavior: 'smooth'
			})
		});
		this.getData()
		this.getuserinfo()
		this.getBannerList();
        this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
	},
	methods: {
		getData() {
			this.getCooperateList()
		},
		// 企业列表
		async getCooperateList() {
			let res = await cooperateList();
			if (res.status == 200) {
				this.cooperatelist = res.data.cooperate_list;
				
				if (!this.cooperate_id) this.cooperate_id = res.data.cooperate_id;
			}
			this.getList2()
		},
		// 企业点击
		tabsHandle(id) {
			this.cooperate_id = id;
			this.column_id= 1;
			this.directory_id= 1;
			this.dirtitle = "";
			// 让当前地址栏添加一个参数 cooperate_id
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					cooperate_id: id,
					column_id: 1,
					directory_id: 1,
					dirtitle: ""
				}
			})
			this.getList2()
		},
		// 栏目列表
		async getList2() {
			let res = await columnList({ cooperate_id: this.cooperate_id });
			if (res.status == 200) {
				this.columnlist = res.data.column_list;
				this.column_id = this.column_id==1?res.data.column_id:this.column_id;
				this.admin_data = res.data.admin_data;
			}
			this.getList3()
		},
		// 栏目点击
		tabsHandle2(id, tcbc_temp_type) {
			this.column_id = id;
			this.directory_id= 1;
			this.dirtitle = "";
			
			// 让当前地址栏添加一个参数 column_id
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					cooperate_id: this.cooperate_id,
					column_id: id,
					directory_id: 1,
					dirtitle: ""
				}
			})

			this.getList3()
			this.adminEdit = false
		},
		// 目录列表
		async getList3() {
			let res2 = await directoryList({
				cooperate_id: this.cooperate_id,
				column_id: this.column_id,
				search_key: this.keyword,
			});
			if (res2.status == 200) {
				this.directory_id = this.directory_id==1?res2.data.directory_id:this.directory_id;
				this.dirtitle = this.dirtitle!=''?this.dirtitle:res2.data.curr_directory.tcbcd_title;
				this.directorylist = this.clearArr(res2.data.directory_list);
				this.tcbc_temp_type = res2.data.curr_directory.tcbcd_temp_type;
				this.$nextTick(() => {
					this.$refs.treeRef.setCurrentKey(this.directory_id)
				})
			}
			this.pagination.page = 1
			this.getArticleList()
			let res3 = await columnLinkList({ cooperate_id: this.cooperate_id, column_id: this.column_id });
			if (res3.status == 200) {
				this.columnLinkList = res3.data;
			}
		},
		// 目录点击
		tabsHandle32(item) {
			this.directory_id = item.tcbcd_id;
			

			// 让当前地址栏添加一个参数 directory_id
			this.$router.push({
				path: this.$route.path,
				query: {
					...this.$route.query,
					cooperate_id: this.cooperate_id,
					column_id: this.column_id,
					directory_id: item.tcbcd_id,
					dirtitle: item.title
				}
			})

			this.dirtitle = item.title
			this.pagination.page = 1
			this.getArticleList()

		},
		handleSearch() {
			if(this.keyword==''&&this.iptHide){
				this.iptHide = false
				return
			}else if(this.keyword==''&&!this.iptHide){
				this.iptHide = true
			}
			this.getList3()
		},
		// 获取文章列表
		async getArticleList() {
			console.log(this.directory_id)
			if (this.tcbc_temp_type == 30) this.articlelist = []
			const obj = {
				cooperate_id: this.cooperate_id,
				column_id: this.column_id,
				directory_id: this.directory_id,
				search_key: this.keyword,
				sort_method: this.sort_method,
				page: this.pagination.page,
        paginate: this.pagination.pageSize,
			}
			let res = await articleList(obj);
			if (res.status == 200) {
				this.articlelist = res.data.article_list.data;
				// this.$set(this,"articlelist",res.data.article_list.data)
				this.pagination.total = res.data.article_list.total;
				this.pagination.allPage = res.data.article_list.last_page;
				this.pagination.pageSize = res.data.article_list.per_page
				this.$set(this, "pagination", this.pagination)
				this.$nextTick(() => {
					this.initShare()
				})
				
			}
		},
		// 置顶
		async handleTopUp(item) {
			this.top_id = item.tcba_id
			if (item.tcba_rec == 1000) {
				this.topupSubmitted({})
			} else {
				this.$refs.topupDialog.openModal();
			}
		},
		async topupSubmitted(content) {
			this.topLoading = true;
			let obj = {
				twsid: 1,
				tcb_id: this.cooperate_id,//企业ID
				tcba_id: this.top_id,//文章ID
				tp_id: this.top_id,
				...content
			}
			let res = await topUp(obj);
			if (res.status == 200) {
				this.$message.success(res.msg);
				this.$refs.topupDialog.closeModal();
				this.pagination.page = 1
				this.getArticleList();
			}
			setTimeout(() => {
				this.topLoading = false;
			}, 1000);
		},
		// 置精华
		async handlesSetEssence(item) {
			const loading = this.$loading()
			let res = await setEssence({
				twsid: 1,
				tcb_id: this.cooperate_id,//企业ID
				tcba_id: item.tcba_id,//文章ID
			});
			loading.close()
			if (res.status == 200) {
				this.$message.success(res.msg);
				this.getArticleList();
			}
		},
		// 管理员删除
		handleDelAdmin(item) {
			/** 弹窗再次确认操作 */
			this.$confirm(this.$t("此操作将删除该条记录, 是否继续?"), this.$t("提示"), {
				confirmButtonText: this.$t("确定"),
				cancelButtonText: this.$t("取消"),
				type: "warning",
			}).then(async () => {
				const res = await adminDel({
					tcb_id: item.tcb_id,
					tcba_id: item.tcba_id
				})
				if (res.status == 200) {
					this.$message.success(res.msg);
					this.getArticleList();
				}
			})
		},
		// 用户删除
		async handleDel(item) {
			/** 弹窗再次确认操作 */
			this.$confirm(this.$t("此操作将删除该条记录, 是否继续?"), this.$t("提示"), {
				confirmButtonText: this.$t("确定"),
				cancelButtonText: this.$t("取消"),
				type: "warning",
			}).then(async () => {
				const res = await del({
					tcb_id: item.tcb_id,
					tcba_id: item.tcba_id
				})
				if (res.status == 200) {
					this.$message.success(res.msg);
					this.getArticleList();
				}
			})
		},
		// 文章编辑 获取详情
		async handleEdit(item) {
			const res = await editGet({
				tcb_id: item.tcb_id,
				tcba_id: item.tcba_id
			})
			if (res.status == 200) {
				this.formData = res.data
				this.$nextTick(() => {
					this.$refs.cooperateDialog.openModal();
				})
			}
		},
		// 设为典型疑问
		async handleSetTypical(item) {
			const loading = this.$loading()
			let res = await setTypical({
				twsid: 1,
				tcb_id: this.cooperate_id,//企业ID
				tcba_id: item.tcba_id,//文章ID
			});
			loading.close()
			if (res.status == 200) {
				this.$message.success(res.msg);
				this.getArticleList();
			}
		},
		// 查看用户信息
		handleUserinfo(user_id) {
			this.user_id = user_id;
			this.$refs.avatarDialog.openModal();
		},
		// 关注弹框用户
		async handlePostSubmitted(id) {
			this.publisherFollowLoading = true
			// setuserfollowAdd
			let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
			if (res.status == 200) {
				this.$message.success(res.msg);
			}
			this.publisherFollowLoading = false
		},
		// 设为已解决
		async handleSolved(item) {
			const loading = this.$loading()
			let res = await solved({
				twsid: 1,
				tcb_id: this.cooperate_id,//企业ID
				tcba_id: item.tcba_id,//文章ID
			});
			loading.close()
			if (res.status == 200) {
				this.$message.success(res.msg);
				this.getArticleList();
			}
		},
		handleUserinfo(user_id) {
			this.user_id = user_id;
			this.$refs.avatarDialog.openModal();
		},
		// 关注弹框用户
		async handlePostSubmitted(id) {
			this.publisherFollowLoading = true
			// setuserfollowAdd
			let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
			if (res.status == 200) {
				this.$message.success(res.msg);
			}
			this.publisherFollowLoading = false
		},
		// 下载
		downloadFile(item, index) {
			const loading = this.$loading()
			if (this.download_able) {
				this.download_able = false;
				let tcba_id = item.tcba_id;
				let file = item.tcba_annex_arr[0];
				let att_id = file.att_id;
				let num = file.download_times;
				num = num + 1;
				this.$set(this.articlelist[index].tcba_annex_arr[0], 'download_times', num)
				window.location.href = "/protal/download/downAnnex?content_id=" + tcba_id + "&att_id=" + att_id + "&type=100";
				setTimeout(() => {
					this.download_able = true;
					loading.close()
				}, 2000);
			}
		},
		// 分享
		showShareMenu(item) {
			this.shareItem = item
		},
		handleShare(item, index) {
			sharePoints({ tcba_id: item.tcba_id }).then(() => {
				item.tcba_share++;
				this.$set(this.articlelist[index], 'tcba_share', item.tcba_share)
			}).finally(() => {
			})
		},
		// 收藏
		async handleLike(item, index) {
			const loading = this.$loading()
			let res = await articleCollection({
				tcba_id: item.tcba_id,//文章ID
			});
			loading.close()
			if (res.status == 200) {
				this.$message.success(res.msg);
				item.have_collection = !item.have_collection;
				this.$set(this.articlelist[index], 'have_collection', item.have_collection)
			}

		},
		setCover(index) {
			const video = this.$refs.videoPlayer[index];
			video.currentTime = 2 / 24;
		},
		handleScroll() {
			// 检查当前滚动位置
			if (window.scrollY >= 20) {
				this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 1);");
			} else {
				this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 0.2);");
			}
		},
		// 左侧目录展开
		hideChild(item, index) {
			item.hide = !item.hide;
			this.$set(this.directorylist, index, { ...item })
		},
		// 获取问答目录列表并打开发布
		async showCooperateAskDialog() {
			if (this.userinfo.user_id === undefined || this.userinfo.user_id < 1) {
				this.$jumpLogin();
				return false;
			}
			let column_id = "";
			this.columnlist.map(v => {
				if (v.tcbc_temp_type == 40) {
					column_id = v.tcbc_id;
				}
			})
			this.fbType = 40
			let res2 = await directoryList({ cooperate_id: this.cooperate_id, column_id: column_id });
			if (res2.status == 200) {
				this.directoryData = this.clearArr(res2.data.directory_list);
				this.$nextTick(() => {
					this.$refs.cooperateDialog.openModal();
				})
			}
		},
		clearArr(arr) {
			arr.forEach(item => {
				if (item.children && item.children.length === 0) {
					delete item.children;
				} else if (item.children && item.children.length > 0) {
					this.clearArr(item.children);
				}
			});
			return arr;
		},
		// 发布帖子
		async showDialog() {
			this.fbType = 0
			if (this.userinfo.user_id === undefined || this.userinfo.user_id < 1) {
				this.$jumpLogin();
				return false;
			}
			this.$nextTick(() => {
				this.$refs.cooperateDialog.openModal();
			})
		},
		async handleSubmitted(content) {
			let obj = {
				tcb_id: this.cooperate_id,
				...content
			}
			let res = obj.tcba_id ?  await edit(obj) : await add(obj);
			if (res.status == 200) {
				this.$message.success(res.msg);
				this.getArticleList()
			}
		},
		// 获取banner信息
		async getBannerList() {
			let res = await getBanner({ dd_id: 40 });
			if (res.status == 200) {
				this.bannerList = res.data;
			}

		},
		async getuserinfo() {
			let res = await getMyInfo();
			if (res.status == 200) {
				// 17621655627
				this.userinfo = res.data;
			}
		},
		// 分页切换
		handleCurrent(page) {
			this.pagination.page = page;
			this.getArticleList()
		},
    handlePageSize(pageSize) {
      this.pagination.page = 1;
			this.pagination.pageSize = pageSize;
			this.getArticleList()
		},
		// 面包屑导航跳转
    async handleLink(id, link, type,item) {
			if (type == 20) {
				let str = "/cn";
				let Language = localStorage.getItem("currentLanguage"); //获取本地语言
				if (Language && Language != "zh") {
					str = "/" + Language;
				}
				// this.$router.push(str + '/cooperate/info/'+id);
				window.open(str + '/cooperate/info/' + id);
			} else if (link && type == 10) {
        await addExternalLinkHits({tcba_id: id});
        item.tcba_hits++;
				window.open(link, '_blank');
			}
		},
		// 根据文件类型获取图片
		getDoc(title) {
			const filePath = title;
			const fileType = filePath.split(".").pop(); // 获取扩展名

			let png = ["png", "jpg", "bmp", "tif", "gif", "pcx", "svg", "webp"];
			let doc = ["doc", "docx", "DOC", "ODCX"];
			let ppt = ["ppt", "pptx", "pps", "ppsx", "pot", "potx", "odp", "xml"];
			let pdf = [
				"pdf",
				"pdf/a",
				"pdf/x",
				"pdf/e",
				"pdf/ua",
				"pdf/1.4",
				"pdf/1.5",
				"pdf/2.0",
			];
			let mp4 = [
				"mp4",
				"mkv",
				"avi",
				"mov",
				"wmv",
				"flv",
				"webm",
				"mpeg",
				"mpg",
				"3gp",
				"mp3",
				"wav",
				"aac",
				"flac",
				"ogg",
				"wma",
				"m4a",
				"aiff",
				"opus",
			];
			let txt = [
				"txt",
				"csv",
				"log",
				"md",
				"xml",
				"json",
				"html",
				"yaml",
				"ini",
				"tex",
			];
			let excel = ["xls", "xlsx", "xlsm", "xlsb", "csv", "txt", "xml", "ods"];

			let typePath = "default";
			if (png.includes(fileType)) {
				typePath = "png";
			} else if (doc.includes(fileType)) {
				typePath = "doc";
			} else if (ppt.includes(fileType)) {
				typePath = "ppt";
			} else if (pdf.includes(fileType)) {
				typePath = "pdf";
			} else if (mp4.includes(fileType)) {
				typePath = "mp4";
			} else if (txt.includes(fileType)) {
				typePath = "txt";
			} else if (excel.includes(fileType)) {
				typePath = "excel";
			} else {
				typePath = "default";
			}

			return require("@/assets/images/file/" + typePath + ".png");
		},
		initShare() {
			setTimeout(() => {
				let str = "/cn";
				let Language = localStorage.getItem("currentLanguage"); //获取本地语言
				if (Language && Language != "zh") {
					str = "/" + Language;
				}
				const setConf = (cmd, config) => {
					config.bdUrl = window.location.origin + str + '/cooperate/info/' + this.shareItem.tcba_id;
					console.log(config.bdUrl)
					return config;
				}
				window._bd_share_config = {
					"common": {
						"bdSnsKey": {},
						"bdText": "", // 可以设置一个默认的分享文本
						"bdMini": "1",
						"bdMiniList": false,
						"bdPic": "", // 不需要分享图片
						"bdStyle": "1",
						"bdSize": "16",
						"bdUrl": "", // 初始设置的 URL
						"onBeforeClick": setConf,
					},
					"share": {},
					"image": {
						"viewList": ["tsina", "tqq", "qzone", "weixin", "sqq"],
						"viewText": "分享到：",
						"viewSize": "16"
					},
					"selectShare": {
						"bdContainerClass": null,
						"bdSelectMiniList": ["tsina", "tqq", "qzone", "weixin", "sqq"]
					}
				};
				window._bd_share_main.init();
				// 动态加载百度分享的 JS
				// var script = document.createElement('script');
				// script.src = '/static-share/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5);
				// document.getElementsByTagName('head')[0].appendChild(script);

			}, 1000);
		},
	}
}
</script>

<style lang="scss" scoped>
.coopmain {
	padding-top: 60px;
	width: 100%;
}

.banner-box {
	width: 100%;
	// height: 316px;

	.swiper-container {
		// height: 316px;
		position: relative;

		.banner-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		:deep .swiper-pagination {
			width: 100%;
			height: 10px;
			position: absolute;
			bottom: 40px !important;
			left: 0;
			text-align: center;

			.swiper-pagination-bullet {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 6px;
				background-color: rgba(0, 0, 0, 0.2);
				margin: 0 8px;
				transition: all 0.36s;

				&.swiper-pagination-bullet-active {
					background-color: rgba(0, 0, 0, 0.7);
					border-radius: 6px;
					width: 26px;
					opacity: 0.8;
				}
			}
		}
	}

}

.pr {
	padding-right: calc((100% - 1400px) / 2);
}

.pl {
	padding-left: calc((100% - 1400px) / 2);
}

@media (max-width: 1510px) {
	.pr {
		padding-right: calc((100% - 1200px) / 2);
	}

	.pl {
		padding-left: calc((100% - 1200px) / 2);
	}
}

button {
	border: none;
	font-size: 16px;
	outline: none;
	cursor: pointer;
	outline: none;
}

.sharewx-link {
  width: 120px;
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.2);
  right: -180px;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.36s;

  a {
      padding-left: 22px;
      position: relative;
      z-index: 10000;
  }

  a:hover {
      color: #b7251e;
  }
}

.share-box:hover {
  .sharewx-link {
      right: -30px;
      bottom: 0;
      opacity: 1;
      visibility: visible;
  }
}
.cooperation-box {
	background-color: #fff;
	padding-bottom: 60px;

	.cooperation-tab {
		padding-top: 24px;

		.left {
			&::before {
				content: "";
				display: inline-block;
				width: 4px;
				height: 20px;
				background: #b7251e;
				margin-right: 11px;
			}

			span.active {
				color: #282828;
			}

			span {
				font-size: 22px;
				font-weight: bold;
				color: #969696;
				cursor: pointer;
				margin-right: 30px;
				transition: all 0.36s;
			}
		}

		.more {
			font-size: 18px;
			color: #989898;

			.iconfont {
				font-size: 16px;
				margin-left: 2px;
			}
		}
	}

	.cooperation-card {
		padding-top: 40px;
		overflow: hidden;
		transition: all 0.36s;
		position: relative;
		height: 156px;
		margin-bottom: 16px;
		&.show{
			height: auto;
			.more{
				.iconfont{
					transform: rotate(90deg);
				}
			}
		}
		.innerbox{
			// background-color: #f8f8f8;
			width: 100%;
			padding: 2px;
			gap: 15px;
		}
		.more{
			position: absolute;
			right: 0;
			top: 36px;
			display: flex;
			align-items: center;
			font-size: 18px;
			color: rgba(77, 77, 77, 1);
			height: 26px;
			cursor: pointer;
			.iconfont{
				margin-left: 4px;
				display: block;
				transition: transform 0.3s;
			}
		}
		.list {
			width: calc(25% - 11px);
			height: 110px;
			background-color: #ffffff;
			border-radius: 6px;
			overflow: hidden;
			padding: 19px 20px;
			transition: box-shadow 0.36s, transform 0.36s;
			cursor: pointer;
			border: solid 1px #f8f8f8;
			box-shadow: 0px 6px 0px #f8f8f8;
			&:last-child{
				margin-right: 0;
			}
			.logo {
				width: 40px;
				max-height: 80px;
			}

			.text-box {
				overflow: hidden;
				margin-left: 10px;
				flex: 1;

				.t1 {
					font-size: 20px;
					color: #282828;
					line-height: 30px;
					font-weight: bold;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.desc {
					font-size: 14px;
					line-height: 24px;
					color: #666666;
				}
			}

			&.active,
			&:hover {
				transform: translateY(-2px);
				border: solid 1px #b7251e;
				box-shadow: 0px 4px 0px #b7251e;
			}
		}
	}

	.cooperation-type {
		min-height: 60px;
		background-color: #ffffff;
		border-radius: 10px;
		padding: 10px 0 20px;

		.cooperation-tabs {
			font-size: 15px;
			line-height: 24px;
			max-width: 100%;
			overflow: hidden;

			a.active {
				border-color: #b7251e;
				font-weight: bold;
			}
			a:hover {
				border-color: #b7251e;
			}
			a {
				color: rgba(25, 25, 25, 1);
				font-size: 16px;
				margin-right: 20px;
				cursor: pointer;
				border-bottom: 1px solid transparent;
				transition: all .5s;
			}
		}

		form {
			.ipt {
				width: 323px;
				height: 34px;
				background-color: #ffffff;
				border-radius: 19px;
				padding: 0 0 0 20px;
				border: solid 1px #e8f0fe;
				&.hide{
					border: none;
					width: auto;
					input{
						display: none;
					}
					&:hover .iconfont.search-cancel{
						opacity: 0;
					}
				}
				input{
					font-size: 14px;
				}
				.iconfont {
					color: #b7251e;
					font-size: 16px;
					margin-right: 12px;

					&.search-cancel {
						margin-right: 0;
						line-height: 12px;
						margin-top: 2px;
						opacity: 0;
						cursor: pointer;
						transition: all 0.36s;
					}
				}

				&:hover {
					.iconfont.search-cancel {
						opacity: 1;
					}
				}

				button {
					background: transparent;
					font-weight: normal;
					flex-shrink: 0;
					margin-left: 10px;
					.iconfont {
						font-size: 18px;
						color: #333;
					}
				}
			}

			button {
				font-size: 14px;
				margin-left: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				line-height: 32px;

				.iconfont {
					font-size: 12px;
					margin-right: 2px;
				}

				&.b1 {
					width: 95px;
					height: 32px;
					border: 1px solid #b7251e;
					background-color: #fff;
					border-radius: 16px;
					color: #b7251e;
				}

				&.b2 {
					width: 95px;
					height: 32px;
					background-color: #b7251e;
					border-radius: 16px;
					color: #fff;
				}
			}
		}
	}

	.cooperation-substance {
		.left-box {
			width: 325px;
		}

		.right-box {
			width: calc(100% - 325px - 16px);
			height: fit-content;
			border: 1px solid rgba(243, 243, 243, 1);
			border-radius: 8px;
			box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);	
		}

		.catalogue {
			width: 100%;
			padding: 20px 0;
			border-radius: 10px;
			border: 1px solid rgba(243, 243, 243, 1);
			border-radius: 8px;
			box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);

			.main-title {
				margin: 0 20px;
				font-weight: 700;
				font-size: 22px;
				color: #3d3d3d;
				line-height: 30px;
			}

			.demo-tree {
				padding: 20px;

				:deep .el-tree {
					color: #333;

					.el-tree-node.is-current>.el-tree-node__content {
						background: rgba(252, 244, 243, 1);
						color: #b7251e;
						&::before{
							border-color: #b7251e;
						}
						&::after{
							background-color: #b7251e;
						}
						.el-tree-node__expand-icon {
							&.is-leaf {
								color: transparent;
							}
						}
					}

					.el-tree-node__label {
						font-size: 16px;
					}

					.el-tree-node__expand-icon {
						font-size: 16px;
						color: #333;
						position: absolute;
						right: 4px;
						&.is-leaf {
							display: none;
						}
					}
					&>.el-tree-node>.el-tree-node__content {
						padding-left: 20px;
						&::before{
							content: "";
							width: 12px;
							height: 12px;
							border: 1px solid #333;
							border-radius: 50%;
							position: absolute;
							left: 16px;
							top: calc(50% + 1px);
							transform: translateY(-50%);
						}
						&::after{
							content: "";
							width: 6px;
							height: 6px;
							background-color: #333;
							border-radius: 50%;
							position: absolute;
							left: 20px;
							top: calc(50% + 1px);
							transform: translateY(-50%);
						}
					}
					.el-tree-node__content {
						height: 56px;
						border-radius: 8px;
						margin-bottom: 4px;
						padding-left: 0 !important;
						position: relative;
						&:hover{
							background-color: transparent;
							color: #b7251e;
						}
						&:hover::before{
							border-color: #b7251e;
						}
						&:hover::after{
							background-color: #b7251e;
						}
						.el-tree-node__label{
							padding: 0 10px 0 44px;
							text-overflow: ellipsis;
							overflow: hidden;
						}
					}
				}
			}
		}

		.cooperation-link {
			width: 100%; 
			border-radius: 10px;
			background-color: #ffffff;
			border: 1px solid rgba(243, 243, 243, 1);
			border-radius: 8px;
			box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
			padding: 20px;
			margin-top: 16px;

			.main-title {
				font-weight: 700;
				font-size: 22px;
				color: #3d3d3d;
				line-height: 30px;

			}

			.link-box {
				padding-top: 14px;

				.list2 {
					font-size: 16px;
					padding: 14px 14px 14px 44px;
					position: relative;
					&::before{
						content: "";
						width: 12px;
						height: 12px;
						border: 1px solid #333;
						border-radius: 50%;
						position: absolute;
						left: 16px;
						top: calc(50% + 1px);
						transform: translateY(-50%);
					}
					&::after{
						content: "";
						width: 6px;
						height: 6px;
						background-color: #333;
						border-radius: 50%;
						position: absolute;
						left: 20px;
						top: calc(50% + 1px);
						transform: translateY(-50%);
					}
					&:hover{
						background-color: transparent;
						color: #b7251e;
					}
					&:hover::before{
						border-color: #b7251e;
					}
					&:hover::after{
						background-color: #b7251e;
					}
				}
				.list {
					padding: 14px;
					border-bottom: 1px solid #eaeaea;

					&:last-child {
						border-bottom: none;
					}

					.logo {
						text-align: center;
						width: 40px;

						img {
							max-width: 40px;
							max-height: 80px;
						}
					}

					.name {
						margin-left: 32px;
					}

					.iconfont {
						opacity: 0.7;
					}
				}
			}
		}

		.right-contentbox {
			background-color: #ffffff;
			padding: 24px 40px;
			border-radius: 10px;

			.community-center {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.option-box {
					flex-shrink: 0;
					input {
						width: 16px;
						height: 16px;
						overflow: hidden;
						background: rgba(255, 255, 255, 0.9);
						border-radius: 3px 3px 3px 3px;
						border: 1px solid #dbdcde;
						margin-right: 4px;
						position: relative;
						top: 2px;
					}

					label {
						font-weight: 400;
						font-size: 16px;
						color: #333;
						line-height: 16px;
						margin-left: 24px;
						margin-right: 0;
					}
					.el-button{
						font-size: 14px;
						min-width: 80px;
						margin-left: 64px;
						color: rgba(25, 25, 25, 1);
						border: 1px solid rgba(179, 179, 179, 1);
						background: transparent;
						position: relative;
						&:hover{
							opacity: 0.8;
						}
						&::before{
							content: "";
							height: 22px;
							position: absolute;
							left: -32px;
							top: 2px;
							border: 1px solid rgba(226, 226, 226, 1);
						}
					}
				}
			}

			.cooperation-answer {
				padding-top: 20px;
				.list {
					cursor: pointer;
					position: relative;
					border-bottom: 1px solid rgba(226, 226, 226, 1);
					padding: 16px 16px 8px;
					display: flex;
					transition: border-color .5s ease;
					&:hover{
						border-color: #b7251e;
						.text-box {
							.t1{
								color: #b7251e;
							}
						}
					}
					.topbox{
						display: flex;
						justify-content: space-between;
						align-items: flex-start;
						margin-bottom: 12px;
						position: relative;
						z-index: 2;
						.topleft{
							display: flex;
							width: calc(100% - 180px);
						}
						.t1 {
							max-width: calc(100% - 130px);
							font-size: 18px;
							line-height: 30px;
							font-weight: bold;
							color: #282828;
							transition: color .3s ease;
						}
						.rightbtn {
							flex-shrink: 0;
							padding-top: 3px;
							.el-tag {
								margin-left: 10px;
								border: none;
								color: #fff;
								&.el-tag--warning{
									background: rgba(253, 185, 6, 1);
								}
								&.el-tag--success{
									background: rgba(215, 17, 17, 1);
								}
							}
						}

						.edit-btn {
							padding-top: 3px;
							.el-button{
								font-size: 14px;
							}
						}
					}
					.bottom{
						display: flex;
						align-items: center;
						justify-content: space-between;
					}
					.titles {
						margin-right: 20px;
						display: flex;
						align-items: center;
						p {
							max-width: 200px;
							font-size: 14px;
							color: #333;
							margin-left: 12px;
						}
					}

					.text-box {
						width: 100%;
						flex-shrink: 1;

						.dates {
							font-size: 14px;
							line-height: 30px;
							color: #888888;

							p {
								margin-right: 14px;
							}
						}
					}

				}
			}

			.cooperation-video {
				padding-top: 20px;

				.list {
					cursor: pointer;
					width: calc(33.33% - 14px) !important;
					background-color: #ffffff;
					border-radius: 6px;
					border: solid 1px #e8e8e8;
					margin-bottom: 21px;
					overflow: hidden;
					margin-right: 21px;
					position: relative;

					.essence-box {
						width: 18px;
						height: 18px;
						border-radius: 2px;
						background: rgba(253, 185, 6, 1);
						margin-right: 7px;
						display: inline-block;
						line-height: 18px;
						text-align: center;
						color: #fff;
						font-size: 14px;
						font-weight: normal;
						margin-top: 5px;
						vertical-align: top;
						&.red{
							background: rgba(215, 17, 17, 1);
						}
					}

					&:hover {
						.t1 {
							color: #b7251e;
						}

						video,
						.video-icon {
							transform: scale(1.1);
						}
					}

					&:nth-child(3n) {
						margin-right: 0;
					}

					.poster-box {
						width: 100%;
						height: 160px;
						position: relative;
						overflow: hidden;

						video {
							width: 100%;
							height: 100%;
							object-fit: cover;
							transition: transform 0.3s ease-in-out;
						}

						.video-icon {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
							width: 100%;
							height: 100%;
							transition: transform 0.3s ease-in-out;
						}

						.video-number {
							width: 100%;
							position: absolute;
							padding: 8px 16px;
							left: 0;
							bottom: 0;
							color: #ffffff;
							z-index: 1;
							font-size: 14px;
							background: linear-gradient(0deg, #0005, transparent);
							.iconfont {
								margin-right: 14px;
								font-size: 14px;
							}
						}
					}

					.t1 {
						line-height: 28px;
						// height: 72px;
						font-size: 18px;
						// font-weight: 600;
						color: #333;
						padding: 8px 16px;
						transition: color 0.3s ease-in-out;
					}

					.date {
						color: rgb(89, 89, 89);
						font-size: 14px;
						line-height: 22px;
						padding: 0 16px 8px;
					}

					.btns {
						padding: 0 16px 4px;
						display: flex;
						justify-content: flex-end;
						.el-button {
							margin-left: 20px;
							margin-right: 0;
							margin-bottom: 6px; 
							font-size: 14px;

							&:last-child {
								margin-right: 0;
							}
						}
					}
				}
			}

			.empty-box {
				text-align: center;
				border-radius: 6px;
				padding: 36px 0;

				img {
					width: 140px;
				}

				p {
					font-size: 16px;
					color: #e0e2e6;
					margin-top: 12px;
				}
			}

			.cooperation-list {
				padding-top: 18px;

				.list {
					display: block;
					padding: 16px 16px 10px;
					border-bottom: 1px solid rgba(226, 226, 226, 1);
					position: relative;
					transition: border-color 0.3s ease-in-out;
					&.red{
						&::after{
							content: "";
							width: 440px;
							height: 100%;
							background: linear-gradient(-64.32deg, rgba(255, 0, 0, 0.11) 1%,rgba(196, 196, 196, 0) 100%);
							opacity: 0.6;

							position: absolute;
							right: -40px;
							top: 0;
							// z-index: -1;
						}
					}
					.topbox{
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 12px;
						position: relative;
						z-index: 2;
						.topleft{
							display: flex;
							align-items: center;
							width: calc(100% - 214px);
						}
						&.en{
							.topleft{
								width: calc(100% - 320px);
							}	
						}
						.essence-box {
							width: 18px;
							height: 18px;
							border-radius: 2px;
							background: rgba(253, 185, 6, 1);
							margin-right: 7px;
							display: inline-block;
							line-height: 18px;
							text-align: center;
							color: #fff;
							font-size: 14px;
							font-weight: normal;
							flex-shrink: 0;
							&.red{
								background: rgba(215, 17, 17, 1);
							}
						}
						.logo {
							width: 32px;
							margin-right: 8px;
							flex-shrink: 0;
						}
						.titles {
							font-size: 18px;
							font-weight: bold;
							line-height: 30px;
							width: calc(100% - 50px);
							color: #282828;
							cursor: pointer;
							transition: color 0.3s ease-in-out;
						}
						.edit-btn{
							.el-button{
								font-size: 13px;
								margin-left: 24px;
							}
						}
					}

					&:hover {
						.titles {
							color: #b7251e;
						}

						border-color: #b7251e;
					}


					.data-btn {
						display: flex;
						justify-content: space-between;
						align-items: center;
						.date-box {
							line-height: 22px;
							font-size: 14px;
							color: rgb(51,51,51);
							span:nth-child(2) {
								margin-left: 16px;
							}
						}

						.dow-btn {
							// min-width: 190px;
							font-size: 14px;
							color: rgb(51,51,51);
							margin-left: 24px;
							position: relative;
							z-index: 60;

							.iconfont {
								margin-right: 4px;
								color: #333;
							}
							.download-a{
								cursor: pointer;
							}
							.download-a.disabled{
								cursor: default;
								color: rgba(77, 77, 77, 0.5);
								.iconfont {
									color: rgba(77, 77, 77, 0.5);
								}
							}
							.cooperate-collection-btn{
								cursor: pointer;
							}
							.bdsharebuttonbox {
								a {
									margin: 0;
									height: auto;
									font-size: 14px;
									&:last-child{
										margin-top: 12px;
									}
									&.hezuohare{
										background-image: none;
										padding: 6px;
										margin-top: 0;
									}
									&:hover {
										color: #b7251e;
										.iconfont {
											color: #b7251e;
										}
									}
									span {
										position: relative;
										z-index: -1;
									}
								}
							}
							.hits{
								display: flex;
								align-items: center;
								&:hover {
									color: rgb(51,51,51);
									.iconfont {
										color: rgb(51,51,51);
									}
								}
							}

							>div,
							>a {
								margin-left: 12px;

								&:hover {
									color: #b7251e;
									.iconfont {
										color: #b7251e;
									}
								}

								&.sel {
									color: #b7251e;
									.iconfont {
										color: #b7251e;
									}
								}
							}

						}
					}
				}
			}
		}
	}

	.pageing-box {
		padding: 24px 0 0;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		button {
			font-size: 14px;
			margin-right: 8px;
		}

		.el-pagination {
			display: flex;
			align-items: center;
			:deep .el-pagination__sizes{
				height: 32px;
				margin-left: 8px;
			}
			:deep .el-select .el-input{
				width: 90px;
				.el-input__inner{
					width: 100%;
					height: 32px;
				}
			}
		}

		:deep .el-input-number--small {
			width: 32px;
		}

		:deep .el-input__inner {
			padding: 0;
			width: 32px;
			border-radius: 8px;
		}

		.jump-text {
			cursor: pointer;
		}
	}


}

:deep .el-button--info {
	background-color: transparent;
	border: 1px solid #DCDFE6;
	color: #333;
	font-size: 14px;
}

:deep .el-button--warning {
	background-color: #e6a23c33;
	color: #e6a23c;
	font-size: 14px;
}

:deep .el-button--danger {
	background-color: #f56c6c33;
	color: #f56c6c;
	font-size: 14px;
}

:deep .el-button--primary {
	background-color: #b7251e;
	font-size: 14px;
}
</style>